import React, { useContext } from "react";
import Frame from "../../../components/DiscResult/Frame";
import { UserData } from "../../../contexts/UserInfoContext";
import { Link } from "react-router-dom";

const Page = ({ children, testResult, title }) => {
  const { user, userLoaded } = useContext(UserData);

  return (
    <div
      style={{ breakAfter: "page" }}
      className="relative min-w-[795px] max-w-[795px] h-[1040px] flex flex-col gap-20 mb-0 mt-2"
    >
      {/* frame */}
      <Frame page={11} user={testResult?.app ? testResult.app : user} />

      <div className="w-full flex flex-col gap-4 p-10 pt-28">
        {title ? (
          <h2 className="text-3xl text-center text-gray-800 font-black self-center my-3">
            {title}
          </h2>
        ) : (
          ""
        )}

        {user?.tests?.filter((test) => test.test === "disc").length === 0 ? (
          <div className="flex flex-col items-center mt-48 gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-14 h-14 fill-red-500"
            >
              <path
                fill-rule="evenodd"
                d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                clip-rule="evenodd"
              />
            </svg>
            <span className="text-red-500 text-xl font-bold">
              برای مشاهده ادامه جواب ها لطفا تست دیسک را خریداری کنید
            </span>
            <Link
              to={"/shop"}
              target="_blank"
              className="text-yellow-700 flex items-center gap-1"
            >
              <span>برو به فروشگاه</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 stroke-yellow-700"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18"
                />
              </svg>
            </Link>
          </div>
        ) : (
          <div className="w-full flex flex-col gap-4">{children}</div>
        )}
      </div>
    </div>
  );
};

export default Page;
